// Layout — wrapper runt alla sidor som lägger till Navbar.
// Pages behöver inte längre ha egen <main> eller "tillbaka"-knapp.

import type { ReactNode } from 'react';
import Navbar from './Navbar';

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-white text-slate-900 dark:bg-slate-950 dark:text-slate-100">
      <Navbar />
      <main>{children}</main>
    </div>
  );
}
